import { render } from "./SeoPage.vue?vue&type=template&id=2cbbe016"
import script from "./SeoPage.vue?vue&type=script&lang=js"
export * from "./SeoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__